import {observer} from "mobx-react";
import PropTypes from "prop-types";
import React from "react";
import {Spinner} from "../../../components/index";
import userResolver from '../UserResolver'
import {Username} from "./Username";

@observer
export class UserOrLoading extends React.Component {

  static propTypes = {
    user: PropTypes.shape({isLoaded: PropTypes.bool, user: PropTypes.any}), // a user from the UserResolver
    userId: PropTypes.string,
    ...Username.optionsProps
  }

  static defaultProps = {
    justName: false
  };

  userObservable = null

  cacheUserObservable(props) {
    const {user, userId} = this.props
    const userObservable = user || (userId && userResolver.fetchOne(userId))
    if (!userObservable) {
      console.warn('must pass user or userId prop to UserOrLoading')
    } else if (userObservable !== this.userObservable){
      this.userObservable = userObservable
    }
  }

  componentWillMount() {
    this.cacheUserObservable(this.props)
  }

  componentWillReceiveProps(nextProps, nextCtx) {
    this.cacheUserObservable(nextProps)
  }

  render() {
    const {user, userId, ...others} = this.props;
    const userObservable = this.userObservable;
    const loading = userObservable ? !userObservable.isLoaded : true;
    return <Username {...others} loading={loading} user={loading ? null : userObservable.user}/>

  }
}

